import { PageHeading, Mui } from "@osu/react-ui";
import withErrorBoundary from "../../Common/hocs/withErrorBoundary";

const Container = withErrorBoundary(Mui.Container);

function Main(props = defaultProps) {
  const { children, tabIndex = "-1", component = "main", ...rest } = props;

  return (
    <Mui.Box tabIndex={tabIndex} component={component} flexGrow={100} {...rest}>
      <Container maxWidth="lg">
        <Mui.Box component="header" sx={(theme) => ({
          marginTop: theme.spacing(3),
          marginBottom: theme.spacing(),
        })}>
          <PageHeading />
        </Mui.Box>
        {children}
      </Container>
    </Mui.Box>
  );
}

const defaultProps = {
  className: "",
  tabIndex: "-1",
  component: "main",
};

export default withErrorBoundary(Main);
